import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Monaco Editor 已通过 vite-plugin-monaco-editor 本地打包，无需 CDN 配置

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

/* Cache bust Tue Mar 17 12:25:23 CST 2026 */
